const baseKey = '/v1/trader/paymentrequisits'

export const paymentRequisitsAPI = {
  baseKey,
  get: (id: string) => `${baseKey}/${id}`,
  delete: `${baseKey}`,
  create: `${baseKey}/create`,
  disable: (id: string) => `${baseKey}/disable/${id}`,
  enable: (id: string) => `${baseKey}/enable/${id}`,
}
